export default __webpack_public_path__ + "static/media/banner.a2aa546c.jpg";